import IntroImage from 'assets/images/intro-pages/property-insurance.jpg';
import { FlowsIntroLayout } from 'components/flows/common/FlowsIntroLayout/FlowsIntroLayout';
import { Content } from 'components/flows/propertyInsurance/IntroPage/Content';
import { useTranslation } from 'react-i18next';

export const PropertyInsuranceIntroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FlowsIntroLayout introImage={IntroImage} navigationText={t('flows.header.navigation.propertyInsurance')}>
      <Content />
    </FlowsIntroLayout>
  );
};
